
import { EP_GET_DASHBOARD } from '../constants/endPointConstants';
import api from './Api';

const getDashboard = async ({ gameKey = 'all', roomMode = 'all', page = 1, pageSize = 24 } = {}) => {
    const response = await api.get(EP_GET_DASHBOARD, { params: { gameKey, roomMode, page, pageSize } });
    return response.data;
}

export {getDashboard}
